export default __webpack_public_path__ + "static/media/saint.5de56dbf.jpeg";